
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.297 4.8a3.2 3.2 0 116.4 0 3.2 3.2 0 01-6.4 0zm3.2-1.6a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zM2.898 12c0-1.897 1.791-3.2 3.68-3.2h.506l.137.053c.39.148.82.233 1.277.233.459 0 .89-.085 1.277-.233l.138-.053h.505c1.89 0 3.68 1.303 3.68 3.2v.743c0 1.046-.961 1.657-1.828 1.657H4.727c-.867 0-1.829-.611-1.829-1.657V12zm3.68-1.6c-1.29 0-2.08.848-2.08 1.6v.722a.342.342 0 00.229.078h7.543a.342.342 0 00.228-.078V12c0-.752-.789-1.6-2.08-1.6h-.216a5.183 5.183 0 01-1.704.286 5.187 5.187 0 01-1.703-.286h-.217z","fill":"#313131"}})])
          )
        }
      }
    